import { DialogueUIOptionConfig } from "../../components/ui/YouRespondUI";
import { NurseStationComputerUIConfig } from "../../components/ui/NurseStationComputerUI";
import BaseScenarioPart from "../../cvp-webgames-core/Scenario/BaseScenarioPart";
import { Segments } from "../../cvp-webgames-core/Scenario/Segments";
import { constants } from "../../misc/constants";
import { CalmBaseScenario, Window508Type } from "../CalmBaseScenario";
import Scenario3 from "./Scenario3";

export default class Scenario3Part5 extends BaseScenarioPart<CalmBaseScenario> {

	private partIndx = 2;
	
	chapterIds = {
		scenario3_3b_s13: 'CALM - Scenario 3 - 3B - Segment 13'
	}

	constructor(scenario: Scenario3, private onDone: () => void) {
		super(scenario);
		CalmBaseScenario.partIndx = this.partIndx;
	}

	public get videoUrl(): string[] {
		return ['./assets/videos/scenario3/calm-scenario3-avatar' + this.scenario.avatarIndx + '.mp4'];
	}

	public get partId(): string {
		return constants.scenarios.scenario3.parts.level3Part5.id;
	}

	public start() {
		const context = this;
		context.segment1Step1HeatherApproaches();
	}

	private segment1Step1HeatherApproaches() {
		this.scenario.destroyAllUIInstances();
		var context = this;
		context.scenario.displayHeader();
		context.segment2Step1NSCReports();
	}

	

	private segment2Step1NSCReports() {
		var context = this;
		context.scenario.update508Window(Window508Type.NurseStationComputerUI);
		context.scenario.gameManager.UiManager.createUIInstance(constants.uiNames.NurseStationComputerUI, {
			reports: [
				{
					title: 'Incident',
					description: 'Nothing to add to report'
				},
				{
					title: '24 Hour',
					description: 'Interpreter services were used to communicate surgery rationale and obtain consent.'
				},
				{
					title: 'End of Shift',
					description: 'Interpreter services were used to communicate surgery rationale and obtain consent.'
				}
			],
			review: {
				text:
					`
				<p class="regular-description-font" style="margin: 0">
				It is your duty as a Charge Nurse to ensure that
				<span style="color: rgb(222, 225, 156)">
				all patients receive the highest level of patient-centered care. Non-English speaking patients need a certified interpreter to assist the communication process.
				</span>
				Medical interpreters, both in-person and phone-based, are able to translate precise medical terminologies to patients, as well as interpret back patient
				 questions for the provider. Often, a patient will allow a family member to interpret for them. In some instances, this is appropriate. However, when briefing 
				 a patient on an upcoming procedure, like in this scenario, a family member’s interpretation abilities may not be enough. In order to obtain proper informed 
				 consent,
				 <span style="color: rgb(222, 225, 156)">
				 trained medical interpreters are often necessary.<br /><br />
				 Most health care facilities will have at least one method of obtaining interpreter services. 
				</span>
				 In this scenario, a phone-based interpreter was used. Other facilities may
				 <span style="color: rgb(222, 225, 156)">
				 contact a local university, use an on-site certified staff member, or have a contracted team available at all times. 
				</span>
				 </p>
				`
			},
			reflects: [
				{
					title: 'What is the procedure at your facility to locate certified medical interpreters? ',
					answer: ''
				},
				{
					title: 'Do you use telephonic certified medical interpreters? If so, do you use a special three way phone, and where in your facility is it kept?',
					answer: ''
				},
				{
					title: 'If you don’t use telephonic certified medical interpreters, where do you get interpretation services? What happens if it’s the middle of the night?',
					answer: ''
				},
				{
					title: 'What are your processes for hearing impaired patients?',
					answer: ''
				},
				{
					title: 'What are your processes for emergent procedures when consent cannot be obtained?',
					answer: ''
				}
			],
			onClosed: (config: NurseStationComputerUIConfig) => {
				context.scenario.update508Window(Window508Type.Main);
				context.partEnd();
			}
		})
	}

	private partEnd() {
		this.scenario.destroyAllUIInstances();
		var context = this;
		this.scenario.gameManager.customData.saveData.scenarios[this.scenario.currentLevel].badges[context.partIndx].points = CalmBaseScenario.scores[this.partIndx];

		this.scenario.gameManager.customData.saveData.scenarios[this.scenario.currentLevel].badges[context.partIndx].isUnlocked = true;
		this.scenario.gameManager.customData.saveData.scenarios[context.scenario.currentLevel].lastPartId = this.partId;

		this.scenario.gameManager.customData.saveGame(this.scenario.gameManager);

		this.scenario.showBadgingUI(context.partIndx, () => {
			context.onDone();
		});
	}
}